import PropTypes from 'prop-types';

const searchPropsType = PropTypes.shape({
  toggleCalendar: PropTypes.func.isRequired,
  onPartySizeChange: PropTypes.func.isRequired,
  onPartySizeClick: PropTypes.func.isRequired,
  onCollectionsSelect: PropTypes.func.isRequired,
  dropdowns: PropTypes.shape({
    date: PropTypes.bool,
    locations: PropTypes.bool,
    menu: PropTypes.bool,
    search: PropTypes.bool,
    seats: PropTypes.bool,
  }),
  searchFields: PropTypes.shape({
    datepicker: PropTypes.shape({
      config: PropTypes.shape({
        label: PropTypes.string,
      }),
    }),
  }),
  selectedSeats: PropTypes.number,
});

const searchPropsStandardDefault = {
  toggleCalendar: () => {},
  onPartySizeChange: () => {},
  onPartySizeClick: () => {},
  onCollectionsSelect: () => {},
  dropdowns: {
    date: false,
    locations: false,
    menu: false,
    search: false,
    seats: false,
  },
  searchFields: {
    datepicker: {
      config: {
        label: 'Today',
      },
    },
  },
  selectedSeats: 2,
};

export {
  searchPropsType,
  searchPropsStandardDefault,
};
